import Button from '@shared/components/Button/Button';
import { useTranslation } from 'react-i18next';

import logger from 'utils/logger';

import useNotifications from './NotificationsProvider/useNotifications';
import { filterUnreadNotifications } from './utils';

interface MarkAllAsReadButtonProps {
  onClick: () => void;
}

const MarkAllAsReadButton = ({ onClick }: MarkAllAsReadButtonProps) => {
  const { t } = useTranslation();
  const { notificationsState, markAllAsRead } = useNotifications();

  const unreadNotifications = filterUnreadNotifications(notificationsState);

  const handleOnReadCallbacks = async () => {
    for (const notification of unreadNotifications) {
      if (!notification.onRead) continue;

      await notification
        .onRead()
        ?.catch((error) => logger.error('Error while marking notification as read', { id: notification.id, error }));
    }
  };

  const handleClick = () => {
    markAllAsRead();
    handleOnReadCallbacks();
    onClick();
  };

  return (
    <Button
      className="text-primary-50 text-size-sm"
      variant="textSecondary"
      onClick={handleClick}
      disabled={!unreadNotifications.length}
    >
      {t('mark_all_as_read')}
    </Button>
  );
};

export default MarkAllAsReadButton;
